// Page de connexion
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import './Login.css'; // Importer le fichier de style CSS
import { getApiBase } from '../config/env';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState(''); // Message d'erreur
    const [isLoading, setIsLoading] = useState(false); // Etat de chargement
    const BASE = getApiBase(); // plus de const API_BASE_URL ici !

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setErrorMessage('');
        try {
            const response = await fetch(`${BASE}/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });

            if (!response.ok) {
                throw new Error('Identifiants incorrects');
            }

            const data = await response.json();
            login({ token: data.token, email }); // Sauvegarde du jeton et email dans le contexte
            localStorage.setItem('token', data.token); // Sauvegarde le JWT pour les futures requêtes
            navigate('/stock'); // Rediriger après connexion
        } catch (error) {
            console.error(error);
            setErrorMessage(error.message); // Affichage du message d'erreur
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-container page-transition">
            <h2>Connexion</h2>
            <form onSubmit={handleSubmit}>
            <div>
                <label>Email :</label>
                <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                />
            </div>
            <div>
                <label>Mot de passe :</label>
                <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                />
            </div>
            {errorMessage && <div className="alert">{errorMessage}</div>} {/* Affichage de l'erreur */}
            <button type="submit" disabled={isLoading} aria-busy={isLoading}>
                {isLoading ? 'Connexion en cours...' : 'Se connecter'}
            </button>
            </form>
        </div>
    );
};

export default Login;